(function(){
  'use strict';

  function addStyles(){
    if (document.getElementById('erectus-search-mobile-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-search-mobile-styles';
    style.textContent = [
      '#lheader .search-block .btn-search{border:0;background:transparent;cursor:pointer;}',
      '@media (max-width:767px){',
      '#lheader .search-form .search-info{min-height:46px!important;font-size:16px!important;padding:10px 46px 10px 14px!important;}',
      '#lheader .search-form .btn-search{min-width:44px!important;min-height:44px!important;display:flex!important;align-items:center!important;justify-content:center!important;}',
      '.laber_mini_cart .frm_search_input{display:flex!important;align-items:center!important;border:1px solid #e3e3e3!important;border-radius:9px!important;overflow:hidden!important;}',
      '.laber_mini_cart .frm_search_input .search_header__input{min-height:48px!important;font-size:16px!important;padding:10px 12px!important;}',
      '.laber_mini_cart .frm_search_input .search_header__submit{min-width:48px!important;min-height:48px!important;display:flex!important;align-items:center!important;justify-content:center!important;}',
      '.template-search .section-header{padding:6px 12px 12px!important;}',
      '.template-search .section-header .section-title{font-size:21px!important;line-height:1.3!important;margin:0!important;}',
      '.template-search .top-control .control>.control-button{display:none!important;}',
      '.template-search .top-control .filter-choice{margin-left:auto!important;max-width:210px!important;}',
      '.template-search .erectus-search-recovery{max-width:520px!important;margin:18px auto 36px!important;padding:18px!important;border:1px solid #e5e5e5!important;border-radius:12px!important;background:#fff!important;}',
      '.template-search .erectus-search-recovery form{display:flex!important;gap:8px!important;}',
      '.template-search .erectus-search-recovery input[type="search"]{flex:1 1 auto!important;min-width:0!important;min-height:46px!important;padding:10px 12px!important;border:1px solid #d9d9d9!important;border-radius:8px!important;font-size:16px!important;}',
      '.template-search .erectus-search-recovery button{flex:0 0 auto!important;min-height:46px!important;padding:10px 14px!important;border:0!important;border-radius:8px!important;background:#0d0d0d!important;color:#fff!important;font-weight:700!important;}',
      '.template-search .erectus-search-recovery a{display:block!important;margin-top:12px!important;text-align:center!important;font-size:13px!important;text-decoration:underline!important;}',
      '}',
      '@media (max-width:380px){',
      '.template-search .erectus-search-recovery form{display:block!important;}',
      '.template-search .erectus-search-recovery input[type="search"],.template-search .erectus-search-recovery button{width:100%!important;}',
      '.template-search .erectus-search-recovery button{margin-top:8px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function translateSaleBadges(root){
    (root || document).querySelectorAll('.nt_label.onsale').forEach(function(el){
      if ((el.textContent || '').trim().toLowerCase() === 'sale') el.textContent = 'Oferta';
    });
  }

  function addRecoverySearch(){
    if (!document.body || !document.body.classList.contains('template-search')) return;
    if (document.querySelector('.erectus-search-recovery')) return;

    var params = new URLSearchParams(window.location.search);
    var term = (params.get('q') || '').trim();
    var noResults = document.querySelector('.empty-page-content, .main-container .container h1.section-title');
    var visibleProductCards = document.querySelectorAll('.main-content-grid .product-item').length;
    if (!noResults || visibleProductCards > 0) return;

    var wrap = document.createElement('div');
    wrap.className = 'erectus-search-recovery';

    var form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');

    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.value = term;
    input.placeholder = '¿Qué producto buscas?';
    input.setAttribute('aria-label', 'Buscar productos');
    input.setAttribute('enterkeyhint', 'search');

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'type';
    hidden.value = 'product';

    var button = document.createElement('button');
    button.type = 'submit';
    button.textContent = 'Buscar';

    form.appendChild(input);
    form.appendChild(hidden);
    form.appendChild(button);

    var all = document.createElement('a');
    all.href = '/collections/all';
    all.textContent = 'Ver todos los productos';

    wrap.appendChild(form);
    wrap.appendChild(all);

    var host = noResults.closest('.container') || noResults.parentElement;
    if (host) host.appendChild(wrap);
  }

  function run(root){
    addStyles();
    translateSaleBadges(root || document);
    addRecoverySearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function(e){ run(e.target || document); });
  document.addEventListener('search:updated', function(){ run(document); });
})();
